import { Link } from "react-router-dom";

const BornToTradePodcastContentTwo = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row reverse-mobile">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL + "/images/resources/born_to_trade_podcast/born_to_trade_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>Bringing You Closer to the Market</h2>
              <p>
                Trading is more than charts and numbers, it’s about perspective.
                Each episode of the Born to Trade Podcast helps you understand
                the forces shaping global markets, uncover the human side of
                trading, and learn how to adapt your strategy to ever-changing
                conditions. Stay ahead of economic shifts, policy changes, and
                emerging asset classes through balanced discussions and
                practical takeaways from industry veterans. Whether you’re a
                seasoned trader or just getting started, there’s always
                something valuable to tune into.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/register"}
              >
                Register now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BornToTradePodcastContentTwo;
